var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"my-overlay"},[_c('v-row',{staticClass:"fill-height light",attrs:{"align":"center","justify":"center"}},[_c('div',[_c('v-img',{attrs:{"src":"loader_anim.gif"}})],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }